import { Tooltip } from '@ironscales/design-system'

export default Tooltip

export const isTriggerTextTruncated = Tooltip.isTriggerTextTruncated
